import React from 'react';

import { ConfigInterface } from '../../common/interface';

type ConfigContextValue = ConfigInterface | Record<string, never>;

export const ConfigContext = React.createContext<ConfigContextValue>({});

export function ConfigContextProvider({
  children,
  appConfig,
}: {
  children: React.ReactNode;
  appConfig: ConfigInterface;
}) {
  return (
    <ConfigContext.Provider value={appConfig}>
      {children}
    </ConfigContext.Provider>
  );
}
